import React from 'react';
import {useTranslation} from 'react-i18next';
import SMCLabel from '../../../components/Simple/SMCLabel';
import SMCModalButtonContainer from '../../../components/core/SMCModal/SMCModalButtonContainer';
import {SMCCheckbox} from '../../../components/Simple/SMCCheckbox';
import SMCModalBody from '../../../components/core/SMCModal/SMCModalBody';
import SMCButton from '../../../components/Simple/SMCButton';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';


function GatewayWizardStepTwo({
    wizardVars
}) {
    const { t } = useTranslation();
    
    const {
        onRequestClose,
        setWizardStep,
        storeGatewayLogs, setStoreGatewayLogs,
        sendPeriodicReports, setSendPeriodicReports,
        firmwareUpgrades, setFirmwareUpgrades,
        dynamicDns, setDynamicDns,
        sendCloudNotifications, setSendCloudNotifications,
    } = wizardVars;

    const nextButtonFunction = () => {
        setWizardStep(step => step + 1);
    }

    const backButtonFunction = () => {
        setWizardStep(step => step - 1);
    }

    return (
        <>
            <SMCModalBody>
                <SMCLabel bold>{t('SMP.PLAN.CREATE_NEW_PLAN.SERVICES_HEADING')}</SMCLabel>
                <SMCCheckbox checked={storeGatewayLogs} onChange={e => setStoreGatewayLogs(e.target.checked)} label={t("SMP.PLAN.CREATE_NEW_PLAN.STORE")} />
                <SMCCheckbox checked={sendPeriodicReports} onChange={e => setSendPeriodicReports(e.target.checked)} label={t("SMP.PLAN.CREATE_NEW_PLAN.SEND_PERIODIC_REPORTS")} />
                <SMCCheckbox checked={firmwareUpgrades} onChange={e => setFirmwareUpgrades(e.target.checked)} label={t("SMP.PLAN.CREATE_NEW_PLAN.FIRMWARE")} />
                <SMCCheckbox checked={dynamicDns} onChange={e => setDynamicDns(e.target.checked)} label={t("SMP.PLAN.CREATE_NEW_PLAN.DYNAMIC_DNS")} />
                <SMCCheckbox checked={sendCloudNotifications} onChange={e => setSendCloudNotifications(e.target.checked)} label={t("SMP.PLAN.CREATE_NEW_PLAN.SEND_CLOUD_NOTIFICATIONS")} />
                <SMCLabel>{t("SMP.PLAN.CREATE_NEW_PLAN.LINE1")}</SMCLabel>
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={backButtonFunction} style={{ marginRight: 5 }}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="arrow-circle-left" />
                    {t('SMC_GEN_WIZBACK')}
                </SMCButton>
                <SMCButton onClick={nextButtonFunction} style={{ marginRight: 5 }}>
                    {t('SMC_GEN_WIZNEXT')}
                    <FontAwesomeIcon style={{ marginTop: '3px', marginLeft: '5px' }} color="grey" icon="arrow-circle-right" />
                </SMCButton>
                <SMCButton onClick={onRequestClose}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </>
    );
}

export default GatewayWizardStepTwo;